// extracted by mini-css-extract-plugin
export default {"link":"style_link__zvt-b"};